<span class="field-view-value">
    {{formattedValue || '—'}}
  </span>
